module.exports = __webpack_public_path__ + "img/videos_content.ce47052e.png";